export enum NoteType {
    Undefined = 0,
    Note = 1,
    Task = 2
}
